import { mapGetters } from 'vuex';
import { findTimeZone, listTimeZones } from 'timezone-support';
import * as frLocale from 'date-fns/locale/fr';
import { format } from 'date-fns';
import { formatToTimeZone } from 'date-fns-timezone';
import { filter, map, sortBy, startsWith } from 'lodash';

export const timezones = {
    computed: {
        ...mapGetters({
            getTimezone: 'getTimezone',
            getLocale: 'locale',
        }),
        timezoneList: () => {
            return sortBy(map(listTimeZones(), (timezone) => {
                const tz = { timezone: timezone, utcOffset: formatToTimeZone(Date.now(), 'Z', { timeZone: timezone }) };
                tz.text = tz.timezone.replace(/_/g, ' ') + ' ' + tz.utcOffset;
                return tz;
            }), 'utcOffset');
        },
    },
    methods: {
        format(date, formatStr, fr = false, timezone = null) {
            const options = { timeZone: timezone || this.getTimezone };
            if (fr) options.locale = frLocale;
            return formatToTimeZone(date, formatStr, options);
        },
        formatWoTz(date, formatStr) {
            const options = { timeZone: 'UTC' };
            if (this.getLocale === 'fr') options.locale = frLocale;
            return formatToTimeZone(date, formatStr, options);
        },
        formatBrowserTz(date, formatStr) {
            const options = { };
            if (this.getLocale === 'fr') options.locale = frLocale;
            return format(date, formatStr, options);
        },
        isTimezoneValid(timezone) {
            try {
                findTimeZone(timezone);
                return true;
            }
            catch (error) {
                return false;
            }
        },
        filterTimezoneList: function(startString, tzList) {
            return filter(tzList, (tz) => {
                return startsWith(tz.timezone, startString);
            });
        },

        getTimeZoneCode(timezone) {
            return formatToTimeZone(
                new Date(), 'z',
                { timeZone: timezone }
            );
        },
    },
};
